/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable indent */
import React, { useContext, useEffect } from 'react';
import { Breadcrumb } from '@thd-olt-component-react/etch-widgets/dist/components/etch1/Etch1';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { Metadata } from '@thd-olt-component-react/metadata';
import { BackToTop } from '@thd-olt-component-react/back-to-top';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { PrivacyHeader } from '../PrivacyHeader';
import './Privacy-Reports.scss';
import { PrivacyMetadata } from '../PrivacyMetadata';
import { PrivacySubMenu } from '../PrivacySubMenu';

const metadata = {
  title: 'California Privacy Rights & Report – The Home Depot',
  description: 'The Home Depot provides information to the residents of California about their '
    + 'privacy rights and reporting about relevant privacy rights requests on this page.',
  canonical: 'https://www.homedepot.com/privacy/California-Privacy-Rights-and-Report'
};

export const PrivacyReports = () => {
  useContext(ExperienceContext);

  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('exerciseMyPrivacyRights.static.page-load', {
      pageName: 'privacy and security center>california privacy rights and report',
      pageType: 'content',
      primaryCategory: 'privacy and security center',
      subCategory1: 'privacy and security center>california privacy rights and report',
      subCategory2: 'privacy and security center>california privacy rights and report'
    });

  });

  return (
    <div style={{ backgroundColor: '#F5F5F5' }} className="privacy-reports">
      <div className="container">
        <Metadata>
          <PrivacyMetadata
            title={metadata.title}
            description={metadata.description}
            canonical={metadata.canonical}
          />
        </Metadata>

        <div className="cdg-content--header">
          <Row>
            <Col>
              <Breadcrumb breadCrumbs={[
                {
                  url: '/privacy/overview',
                  label: 'Privacy & Security Center'
                },
                {
                  url: '',
                  label: 'California Privacy Rights & Report'
                }]}
              />
            </Col>
          </Row>
        </div>

        <PrivacyHeader privacyInformationActive />

        <div className="cdg-content--body">
          <PrivacySubMenu reportsActive />
          <Row className="white margin-20">
            <Col className="content-summary">
              <Row className="margin-10" />
              <h1>California Privacy Rights & Report</h1>
              <Row className="margin-10" />
              <h2>About the California Consumer Privacy Act</h2>
              <br />
              <p>
                {/* eslint-disable-next-line max-len */}
                The California Consumer Privacy Act (CCPA) provides that California residents have the
                right (subject to certain limitations) to:
                <Row className="margin-10" />
                <ul className="bullet-list-padding">
                  <li>Know and Access the personal information we collect about them</li>
                  <li>Correct the personal information we maintain about them</li>
                  <li>Delete the personal information we collect about them</li>
                  <li>
                    Opt out of having their personal information sold for valuable consideration or
                    shared for certain targeted advertising
                  </li>
                  <li>
                    Limit the use and disclosure of sensitive personal information only to those
                    certain purposes permitted by CCPA
                  </li>
                  <li>
                    Non-discrimination for exercising their privacy rights. We may, however, provide
                    a different level of service or charge a different rate if the difference is
                    reasonably related to the value of the information
                  </li>
                </ul>
                <Row className="margin-10" />
                We disclose your information in ways that do not directly identify you to select
                third parties to enhance your experiences with us, to improve our ability to serve
                you, to keep you aware of our products, services, and offers, and to tailor the
                offers and promotions displayed to you online by select third party advertisers to
                your interests. This disclosure may be considered a &quot;sale&quot; or &quot;sharing&quot;
                of your personal information. Read&nbsp;
                <a href="/privacy/privacy-and-security-statement#InformationDisclosures">
                  Information Disclosures
                </a>&nbsp;for more details.
                <Row className="margin-05" />
                To exercise your California privacy rights, please view the&nbsp;
                <a href="/privacy/exercise-my-privacy-rights">
                  Exercise My Privacy Rights
                </a>&nbsp;page.
              </p>
              <Row className="margin-20" />
              <h2>CCPA Requests in Calendar Year 2024</h2>
              <br />
              <p>This report provides information about the total number of CCPA requests we
                received from individuals determined to be California residents in 2024 and our responses to them.
              </p>
              <Row className="margin-20" />
              <div>
                <table className="cdg-table">
                  <tr className="cdg-report-table_header__header-line">
                    {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                    <th />
                    <th scope="col">Access</th>
                    <th scope="col">Delete</th>
                    <th scope="col">Opt-out<span className="superscript">1</span></th>
                    <th scope="col">Correct</th>
                    <th scope="col">Limit Use of SPI</th>
                  </tr>
                  <tr>
                    <th className="row-header-padding">Received</th>
                    <td>408</td>
                    <td>2,310</td>
                    <td>2,908,181</td>
                    <td>259</td>
                    <td>534</td>
                  </tr>
                  <tr>
                    <th className="row-header-padding">Fulfilled</th>
                    <td>254</td>
                    <td>1,721</td>
                    <td>2,908,181</td>
                    <td>57</td>
                    <td>534</td>
                  </tr>
                  <tr>
                    <th className="row-header-padding">
                      Unable to be Fulfilled
                      <span className="superscript">2</span>
                    </th>
                    <td>154</td>
                    <td>589</td>
                    <td>0</td>
                    <td>202</td>
                    <td>0</td>
                  </tr>
                </table>
              </div>
              <div className="cdg-disclaimers">
                <Row className="margin-10" />
                <span className="superscript">1</span>
                <small>We receive opt-out requests through a variety of methods, as described in our&nbsp;
                  <a href="/privacy/privacy-and-security-statement">
                    Privacy & Security Statement
                  </a>. The opt-out request metrics in this table include
                  opt-out requests received through opt-out preference signals as well as those
                  submitted via other means.
                </small>
                <br />
                <br />
                <span className="superscript">2</span>
                <small>Requests may not be fulfilled for various reasons, including: requests to
                  access, delete or correct do not pass our identity verification process;
                  individuals requesting access, deletion or correction do not confirm their email
                  addresses within the requisite time; individuals submit requests while requests
                  of the same type are being processed; and requests are subject to exemptions
                  established by law.
                </small>

              </div>
              <Row className="margin-20" />
              <h2>
                Average Number of Days to Fulfill CCPA Requests
                <span className="superscript">3</span>
              </h2>
              <Row className="margin-10" />
              <div>
                <table className="cdg-table-2">
                  <colgroup>
                    <col span="2" />
                    <col span="2" />
                    <col span="2" />
                  </colgroup>
                  <tr className="cdg-report-table_header__header-line">
                    <th scope="row">Access</th>
                    <th scope="row">Delete</th>
                    <th scope="row">Opt-out</th>
                    <th scope="row">Correct</th>
                    <th scope="row">Limit Use of SPI</th>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>31</td>
                    <td>7</td>
                    <td>21</td>
                    <td>8</td>
                  </tr>
                </table>
              </div>
              <Row className="margin-10" />
              <span className="superscript">3</span>
              <small>We consider a requestor&apos;s request fulfilled when we inform them that we
                have completed the access, delete, opt-out, correct or limit use of sensitive
                personal information in whole or in part.
              </small>
              <br />
              <br />
              <p>For additional information about our collection, use, and disclosure of personal
                information, please see our&nbsp;
                <a href="/privacy/privacy-and-security-statement">
                  Privacy and Security Statement
                </a>.
              </p>
            </Col>
          </Row>
          <Row className="margin-20" />
          <BackToTop />
        </div>
      </div>
    </div>
  );
};

PrivacyReports.propTypes = {};

PrivacyReports.defaultProps = {};
